import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getUsersRequest, cleanUsers } from '../actions/userActions';
import { permissionsSelector } from '../../auth/selectors/authSelectors';
import UserListSearchHeader from '../components/UserListSearchHeader/UserListSearchHeader';

const mapStateToProps = createStructuredSelector({ permissions: permissionsSelector });
const mapDispatchToProps = {
    getUsersRequest,
    cleanUsers
};

export default connect(mapStateToProps, mapDispatchToProps)(UserListSearchHeader);
